"use strict";

window.PXUTheme.contentCreator.accordion = {
  init: function () {
    const $accordionHeading = $('.accordion > dt > a, [data-cc-accordion] > dt > a');
    $('.accordion > dd, [data-cc-accordion] > dd').attr('aria-hidden', true);
    $accordionHeading.attr('aria-expanded', false);
    $accordionHeading.on('click', function () {
      let state = $(this).attr('aria-expanded') === 'false' ? true : false;
      $(this).attr('aria-expanded', state);
      $(this).parent().next().attr('aria-hidden', !state);
      return false;
    });
    $accordionHeading.on('keydown', function (event) {
      let keyCode = event.keyCode || e.which;
      if (keyCode === 13) {
        $(this).trigger('activate');
      }
    });
  },
  unload: function () {
    $('.accordion > dt > a, [data-cc-accordion] > dt > a').off('click activate');
    $('.accordion > dt > a, [data-cc-accordion] > dt > a').off('keydown');
  }
};
window.PXUTheme.contentCreator.slideshow = {
  init: function () {
    //backwards compatibility with flexslider
    $('.slider, .flexslider').find('li').unwrap();
    $('.slider, .flexslider').flickity({
      pageDots: true,
      lazyLoad: 2
    });
  }
};
window.PXUTheme.animation = {
  init: function () {
    $('[data-scroll-class]').waypoint(function () {
      const animationClass = $(this.element).data('scroll-class');
      $(this.element).addClass('animated').addClass(animationClass);
    }, {
      offset: '70%'
    });
  },
  slideTransition: function ($el, animationName, callback) {
    $el.parents('.flickity-enabled').find('.animated').removeClass('animated ' + animationName);
    $el.addClass('animated').addClass(animationName);
  },
  unload: function ($target) {
    $target.data('scroll-class', '');
  }
};
const deferred = {};
window.PXUTheme.asyncView = {
  /**
   * Load the template given by the provided URL into the provided
   * view
   *
   * @param {string} url - The url to load.
   * @param {string} view - The view to load into.
   * @param {object} options - Config options.
   * @param {string} options.hash - A hash of the current page content.
   */
  load: function (url, view) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    let data;
    if (url in deferred) {
      return deferred[url];
    }
    const $deferred = $.Deferred();
    deferred[url] = $deferred;
    if (options.hash) {
      data = sessionStorage.getItem(url);
      if (data) {
        const deserialized = JSON.parse(data);
        if (options.hash === deserialized.options.hash) {
          delete deferred[url];
          return $deferred.resolve(deserialized).promise();
        }
      }
    }

    // NOTE The $.ajax request has the cache option set to false.
    // This is to prevent certain browsers from returning cached
    // versions of the url we are requesting.
    // See this PR for more info: https://github.com/pixelunion/shopify-asyncview/pull/4
    $.ajax({
      url,
      cache: false,
      data: `view=${view}`,
      dataType: 'html',
      headers: {
        'cache-control': 'no-cache'
      },
      success: response => {
        const el = document.createElement('div');
        el.innerHTML = response;
        const responseOptions = JSON.parse(el.querySelector('[data-options]').innerHTML);
        const htmls = el.querySelectorAll('[data-html]');
        let html = {};
        if (htmls.length === 1 && htmls[0].getAttribute('data-html') === '') {
          html = htmls[0].innerHTML;
        } else {
          for (let i = 0; i < htmls.length; i++) {
            html[htmls[i].getAttribute('data-html')] = htmls[i].innerHTML;
          }
        }
        if (options.hash) {
          try {
            sessionStorage.setItem(url, JSON.stringify({
              options: responseOptions,
              html
            }));
          } catch (error) {
            console.error(error);
          }
        }
        delete deferred[url];
        return $deferred.resolve({
          options: responseOptions,
          html
        });
      },
      error: () => {
        delete deferred[url];
        return $deferred.reject();
      }
    });
    return $deferred.promise();
  }
};
window.PXUTheme.addImageDimension = function (imageUrl, size) {
  var insertPosition = imageUrl.lastIndexOf(".");
  return imageUrl.substring(0, insertPosition) + size + imageUrl.substring(insertPosition);
};
window.PXUTheme.breadcrumbs = {
  init: function (pages) {
    // Show pagination if number of pages is greater than 1
    if (pages > 1) {
      const breadcrumbSpan = document.querySelector('[data-breadcrumb-text]');
      const currentPage = document.querySelector('.paginate')?.dataset.currentPage || 1;
      const totalPages = document.querySelector('.paginate')?.dataset.paginatePages || pages;
      
      const breadcrumbTextElement = document.querySelector('.js-breadcrumb-text');
      if (breadcrumbTextElement) {
        breadcrumbTextElement.classList.remove('is-hidden');
      }
      
      if (breadcrumbSpan && window.PXUTheme.translation) {
        breadcrumbSpan.innerHTML = `${window.PXUTheme.translation.page_text} ${currentPage} ${window.PXUTheme.translation.of_text} ${totalPages}`;
      }
    }
  },
  unload: function ($target) {
    const breadcrumbTextElement = document.querySelector('.js-breadcrumb-text');
    if (breadcrumbTextElement) {
      breadcrumbTextElement.classList.add('is-hidden');
    }
  },
  // New method to refresh breadcrumbs when filters change
  refresh: function() {
    const paginationElement = document.querySelector('.paginate');
    if (paginationElement) {
      const totalPages = parseInt(paginationElement.dataset.paginatePages || 1);
      this.init(totalPages);
    }
  }
};
window.PXUTheme.debounce = function (wait, func, immediate) {
  let timeout = null;
  return function() {  // Use regular function instead of arrow function
    const context = this;
    const args = arguments;
    const later = () => {
      timeout = null;
      if (!immediate && typeof func === 'function') {
        func.apply(context, args);
      }
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow && typeof func === 'function') {
      func.apply(context, args);
    }
  };
};

window.PXUTheme.disclosure = {
  enable: function () {
    const $disclosure = $('[data-disclosure]');
    const $toggle = $('[data-disclosure-toggle]');
    const $disclosureWrap = $('.disclosure__list-wrap');
    const $mobileMenuDisclosureList = $('[data-disclosure-list]');

    // Check if current opened menu is offscreen
    function checkOffScreen($openedToggle) {
      if ($openedToggle.siblings('.disclosure__list-wrap').is(':off-right')) {
        $openedToggle.siblings('.disclosure__list-wrap').addClass('disclosure--left');
      }
    }
    function closeDisclosures(ignoreTarget, currentTarget) {
      if (ignoreTarget === true) {
        $toggle.not(currentTarget).removeClass('is-clicked');
        $toggle.not(currentTarget).attr('aria-expanded', 'false');
      } else {
        $toggle.removeClass('is-clicked');
        $toggle.attr('aria-expanded', 'false');
      }
      $disclosureWrap.removeClass('disclosure--left');
    }

    // Close menus on ESC
    $('body').on('keyup', function (e) {
      if (e.which == '27') {
        closeDisclosures();
      }
    });

    // Close menus on hoverout
    $disclosure.on('mouseleave', function (e) {
      closeDisclosures();
    });

    // Close menus on hoverout
    $disclosure.find('.disclosure-list__item:last-child').on('focusout', function (e) {
      closeDisclosures();
    });

    // On click/focus event for toggling options
    $toggle.on('mouseenter focus', function (e) {
      // Close all other menus
      closeDisclosures(true, this);
      const $target = $(e.currentTarget);
      $target.attr('aria-expanded', 'true').addClass('is-clicked');
      checkOffScreen($target);
    });

    // Mobile toggle logic
    $mobileMenuDisclosureList.on('touchstart', function (e) {
      const $target = $(e.currentTarget);
      $target.parents('.disclosure').addClass('is-clicked');
      closeDisclosures(true, this);
      if ($target.hasClass('is-clicked') == false) {
        $target.attr('aria-expanded', 'true').addClass('is-clicked');
        checkOffScreen($target);
      } else {
        $target.attr('aria-expanded', 'false').removeClass('is-clicked');
        $disclosureWrap.removeClass('disclosure--left');
      }
    });
    $mobileMenuDisclosureList.on('focusout', function (e) {
      closeDisclosures(true, this);
    });

    // Mobile form submitting
    $mobileMenuDisclosureList.on('change', function (e) {
      if (window.PXUTheme.media_queries.medium.matches || !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        const $target = $(e.currentTarget);
        const selectedValue = e.currentTarget.value;
        const disclosureInput = $target.parents('.selectors-form__item').find('[data-disclosure-input]');
        const selectorForm = $target.parents('.selectors-form');
        if (!$target.hasClass('custom-currency')) {
          disclosureInput.val(selectedValue);
          selectorForm.submit();
        } else {
          $target.trigger('click');
        }
      }
    });
  },
  unload: function () {
    $('[data-disclosure]').off();
    $('[data-disclosure-toggle]').off();
    $('.disclosure__list-wrap').off();
  }
};

/*============================================================================
    ImageCompare
  ==============================================================================*/
  
  class ImageCompare extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.sectionId = this.dataset.sectionId;
      this.button = this.querySelector('[data-button]');
      this.draggableContainer = this.querySelector('[data-draggable]');
      this.primaryImage = this.querySelector('[data-primary-image]');
      this.secondaryImage = this.querySelector('[data-secondary-image]');

      this.calculateSizes();

      this.active = false;
      this.currentX = 0;
      this.initialX = 0;
      this.xOffset = 0;

      this.buttonOffset = this.button.offsetWidth / 2;

      this.el.addEventListener("touchstart", this.dragStart, false);
      this.el.addEventListener("touchend", this.dragEnd, false);
      this.el.addEventListener("touchmove", this.drag, false);

      this.el.addEventListener("mousedown", this.dragStart, false);
      this.el.addEventListener("mouseup", this.dragEnd, false);
      this.el.addEventListener("mousemove", this.drag, false);

      // Store reference to 'this' before the event listener
      const self = this;
      let lastWidth = window.innerWidth;
      let resizeTimer;

      function handleResize() {
        const currentWidth = window.innerWidth;
  
        // Only recalculate if width actually changed (ignores address bar show/hide)
        if (currentWidth !== lastWidth) {
          // console.log("Real resize detected!");
          self.calculateSizes(true);
          lastWidth = currentWidth;
        }
      }

      // Use both resize and orientationchange for comprehensive coverage
      window.addEventListener('resize', window.PXUTheme.debounce(250, handleResize));
      window.addEventListener('orientationchange', window.PXUTheme.debounce(500, handleResize));

      document.addEventListener('shopify:section:load', event => {
        if (event.detail.sectionId === this.sectionId && this.primaryImage !== null) {
          this.calculateSizes();
        }
      });
    }
  
    calculateSizes(hasResized = false) {
      // console.log("calculating size");
      this.active = false;
      this.currentX = 0;
      this.initialX = 0;
      this.xOffset = 0;

      
  
      this.buttonOffset = this.button.offsetWidth / 2;
  
      this.elWidth = this.el.offsetWidth;
  
      this.button.style.transform = `translate(-${this.buttonOffset}px, -50%)`;
  
      if (this.primaryImage) {
        this.primaryImage.style.width = `${this.elWidth}px`;
      }
  
      if (hasResized) this.draggableContainer.style.width = `${this.elWidth/2}px`;
    }
  
    dragStart(e) {
      if (e.type === "touchstart") {
        this.initialX = e.touches[0].clientX - this.xOffset;
      } else {
        this.initialX = e.clientX - this.xOffset;
      }
  
      if (e.target === this.button) {
        this.active = true;
      }
    }
  
    dragEnd(e) {
      this.initialX = this.currentX;
      // console.log("dragend");
      this.active = false;
    }
  
    drag(e) {
      if (this.active) {
  
        e.preventDefault();
  
        if (e.type === "touchmove") {
          this.currentX = e.touches[0].clientX - this.initialX;
        } else {
          this.currentX = e.clientX - this.initialX;
        }
  
        this.xOffset = this.currentX;
        this.setTranslate(this.currentX, this.button);
      }
    }
  
    setTranslate(xPos, el) {
      let newXpos = xPos - this.buttonOffset;
      let newVal = (this.elWidth/2) + xPos;
  
      const boundaryPadding = 50;
      const XposMin = (this.elWidth/2 + this.buttonOffset) * -1;
      const XposMax = this.elWidth/2 - this.buttonOffset;
  
      // Set boundaries for dragging
      if (newXpos < (XposMin + boundaryPadding)) {
        newXpos = XposMin + boundaryPadding;
        newVal = boundaryPadding
      } else if (newXpos > (XposMax - boundaryPadding)) {
        newXpos = XposMax - boundaryPadding;
        newVal = this.elWidth - boundaryPadding;
      }
  
      el.style.transform = `translate(${newXpos}px, -50%)`;
      this.draggableContainer.style.width = `${newVal}px`;
    }
  }
  
  customElements.define('image-compare', ImageCompare);



window.PXUTheme.newsletterAjaxForm = {
  init: function () {
    // Selectors
    const $ajaxForm = $('.newsletter-form__wrapper .contact-form');
    $ajaxForm.each(function () {
      const $form = $(this);
      $form.on('submit', function (e) {
        if ($('input[name="challenge"]', $form).val() !== "true") {
          $.ajax({
            type: $form.attr('method'),
            url: $form.attr('action'),
            data: $form.serialize(),
            success: function (data) {
              $form.fadeOut("slow", () => {
                $form.prev('.form__success-message').html(window.PXUTheme.translation.newsletter_form_success);
              });
            },
            error: function (data) {
              $('input[name="challenge"]', $form).val('true');
              $form.submit();
            }
          });
          e.preventDefault();
        }
      });
    });
  },
  unload: function () {
    const $ajaxForm = $('.newsletter-form__wrapper .contact-form');
    const $submitButton = $ajaxForm.find(':submit');
    $submitButton.off();
  }
};
window.PXUTheme.getSectionData = function ($section) {
  try {
    const sectionId = $section.attr('id').replace('shopify-section-', '');
    const $dataEl = $section.find(`[data-section-data][data-section-id=${sectionId}]`).first();
    if (!$dataEl) return {};

    // Load data from attribute, or innerHTML
    const data = $dataEl.data('section-data') || $dataEl.html();
    try {
      return JSON.parse(data);
    } catch (error) {
      console.warn(`Sections: invalid section data found. ${error.message}`);
      return {};
    }
  } catch (error) {
    console.warn(`Sections: unable to find section data. ${error.message}`);
    return {};
  }
};
window.PXUTheme.infiniteScroll = {
  init() {
    this.defaults = {
      grid: '[data-load-more--grid]',
      gridItems: '[data-load-more--grid-item]'
    };
    $('body').off('click', '[data-load-more]');
    $('body').on('click', '[data-load-more]', function (e) {
      e.preventDefault();
      const $button = $(this);
      const url = $button.attr('href');
      window.PXUTheme.infiniteScroll.loadNextPage(url, $button);
    });
    $('body').off('click', '[data-load-more-infinite]');
    $('body').on('click', '[data-load-more-infinite]', function (e) {
      window.PXUTheme.infiniteScroll.enableInfinite();
      $(this).remove();

      // Prevent link from going to next page
      e.stopPropagation();
      return false;
    });
    if ($('[data-load-infinite-scroll]').length) {
      window.PXUTheme.infiniteScroll.enableInfinite();
    }
  },
  loadNextPage(url, $button) {
    $.ajax({
      type: 'GET',
      dataType: 'html',
      url,
      beforeSend() {
        $button.addClass('is-loading');
      },
      success: data => {
        $button.removeClass('is-loading');
        const thumbnails = $(data).find(this.defaults.gridItems);
        const loadMoreButtonUrl = $(data).find('[data-load-more]').attr('href');
        $('[data-load-more]').attr('href', loadMoreButtonUrl);
        $(this.defaults.grid).first().append(thumbnails);

        // Initialize product reviews
        window.PXUTheme.productReviews.init();

        // When there are no additional pages, hide load more button
        if (typeof loadMoreButtonUrl === 'undefined') {
          $('[data-load-more]').addClass('is-hidden');
        }
      },
      error(x, t, m) {
        // console.log(x); 
        // console.log(t);
        console.log(m);
        location.replace(`${location.protocol}//${location.host}`);
      }
    });
  },
  enableInfinite() {
    var infiniteScroll = new Waypoint.Infinite({
      element: $(this.defaults.grid)[0],
      items: '[data-load-more--grid-item]',
      more: '[data-load-infinite]',
      loadingClass: 'loading-in-progress',
      onBeforePageLoad() {
        $('[data-load-infinite]').removeClass('is-hidden');
      },
      onAfterPageLoad() {
        // Initialize product reviews
        window.PXUTheme.productReviews.init();
      }
    });
  },
  unload() {
    $('[data-load-more]').off();
    $('[data-load-infinite]').off();
    $('[data-load-more-infinite]').off();
  }
};
window.PXUTheme.flickityIosFix = function () {
  var touchingCarousel = false,
    touchStartCoords;
};
window.PXUTheme.loadScript = function (name, url, callback) {
  if (window.PXUTheme[name]) {
    callback;
  } else {
    $.ajax({
      url,
      dataType: 'script',
      success: callback,
      async: false
    });
  }
};
window.PXUTheme.applyMasonry = function (selector, gutterSize) {
  let $galleryWrapper = $('.gallery__wrapper--vertical-masonry');
  if ($galleryWrapper.length > 0) {
    $galleryWrapper.imagesLoaded().progress(function () {
      $galleryWrapper.isotope({
        layoutMode: 'masonry',
        itemSelector: selector,
        percentPosition: true,
        masonry: {
          columnWidth: selector,
          gutter: gutterSize
        }
      });
    });
  }
};
window.PXUTheme.applyHorizontalMasonry = function () {
  let $galleryWrapper = $('.gallery__wrapper--horizontal-masonry');
  $galleryWrapper.find('.gallery__item').each(function (e) {
    var wrapper = $(this);
    var imgWidth, imgHeight;
    setTimeout(function () {
      imgWidth = wrapper.find('img').width();
      imgHeight = wrapper.find('img').height();
      wrapper.css("flex-basis", imgWidth * 200 / imgHeight);
      wrapper.css("flex-grow", imgWidth * 200 / imgHeight);
      wrapper.find("i").css("padding-bottom", imgHeight / imgWidth * 100 + '%');
    }, 100);
  });
};
window.PXUTheme.mobileMenu = {
  init: function () {
    //console.log('people?');
    this.$mobileMenuToggle = $('[data-show-mobile-menu]');
    this.$mobileMenuIcon = $('.mobile-menu__toggle-icon');
    this.$mobileDropDownToggle = $('.mobile-menu .close-dropdown');
   
    $('body').on('click', '[data-show-mobile-menu="false"]', function () {
      //console.log('ello there');
      window.PXUTheme.mobileMenu.open();
    });
    $('body').on('click', '[data-show-mobile-menu="true"]', function () {
      window.PXUTheme.mobileMenu.close();
    });
    $('body').on('click', '.mobile-menu-link', function (e) {
      e.preventDefault();
    });
    //if (window.PXUTheme.jsHeader.enable_sticky === true) {
      //this.enableSticky();
    //}
  },
  open: function () {
    //Get current position on page
    let currentScrollPosition = window.scrollY;
    $('body').attr('data-current-position', currentScrollPosition);
    //console.log('open in utilities');
    // Calculate height of mobile content area
    let mobileMenuMargin = 0;
    let announcementHeight = 0;
    let mobileHeaderHeight = parseInt($('.mobile-header').height());
    if (typeof window.PXUTheme.jsAnnouncementBar !== 'undefined' && window.PXUTheme.jsAnnouncementBar.enable_sticky) {
      //console.log('checkpoint');
      // console.log(window.PXUTheme.jsAnnouncementBar.getAnnouncementHeight());
      announcementHeight = window.PXUTheme.jsAnnouncementBar.getAnnouncementHeight();
    }
    let $stickyMenu = $('#shopify-section-sections--15155717898325__header');
    const StickymenuHeight = $stickyMenu.offsetHeight;
    // console.log(window.scrollY);
    //console.log("blyat")
    mobileMenuMargin = (StickymenuHeight);
    $('.mobile-menu').css({
      height: `calc(100vh - ${mobileHeaderHeight + announcementHeight}px)`,
      top: `${mobileMenuMargin}px`
    });
    
    $('.mobile-menu__content').css({
      marginBottom: `${mobileHeaderHeight + announcementHeight}px`
    });
    $('.mobile-menu__toggle-icon').addClass('is-active');
    $('[data-show-mobile-menu]').attr('data-show-mobile-menu', true);
    $('[data-show-mobile-menu]').attr('aria-expanded', true);
   
    // console.log('checkpointa', window.PXUTheme.jsAjaxCart);
    if (typeof window.PXUTheme.jsAjaxCart !== 'undefined') {
      //console.log('Hiding cart');
      window.PXUTheme.jsAjaxCart.hideMiniCart();
      window.PXUTheme.jsAjaxCart.hideDrawer();
    }

    //Set delay on menu open to get proper page position
    setTimeout(function () {
      $('body').addClass('mobile-menu--opened');
    }, 10);
  },
  close: function () {
    $('body').removeClass('mobile-menu--opened');
    //console.log('close in utilities');
    // Once mobile menu is closed, return back to previous position on page
    /*let lastScrollPosition = $('body').data('current-position');
    window.scrollTo(0, lastScrollPosition);*/
    $('.mobile-menu__toggle-icon').removeClass('is-active');
    $('[data-show-mobile-menu]').attr('data-show-mobile-menu', false);
    $('[data-show-mobile-menu]').attr('aria-expanded', false);
  },
  enableSticky: function () {
    //console.log("sticky enabled");
    window.PXUTheme.jsHeader.disableSticky();
    let $stickyEl = $('#mobile-header');
    let offset = 0;
    if (typeof window.PXUTheme.jsAnnouncementBar !== 'undefined' && window.PXUTheme.jsAnnouncementBar.enable_sticky) {
      offset = window.PXUTheme.jsAnnouncementBar.getAnnouncementHeight();
    }
    $stickyEl.addClass('sticky--enabled');
    //console.log("Sticky--enabled utilities");
    $stickyEl.sticky({
      wrapperClassName: 'header-sticky-wrapper is-mobile-only',
      zIndex: 40,
      topSpacing: offset
    }).on('sticky-start', () => {
      var headerheight = $('#mobile-header').height();
      var annoucementHeight = $('.announcement-sticky-wrapper').height();
      var totalHeight = headerheight + annoucementHeight;
      $stickyEl.parent().parent().find('.search-overlay').addClass('sticky-search').css('top', totalHeight + 'px');
    }).on('sticky-end', () => {
      $stickyEl.parent().parent().find('.search-overlay').removeClass('sticky-search').css('top', '100%');
      // Safety timeout for logo width transition which can throw calculated height off
      setTimeout(() => {
        $stickyEl.sticky('update');
      }, 250);
      $stickyEl.find('.sticky-menu-wrapper').removeClass('is-visible');
    });
  },
  disableSticky: function () {
    let $stickyEl = $('#mobile-header');
    $stickyEl.unstick();
    $stickyEl.removeClass('sticky--enabled');
    setTimeout(function () {
      $('.header-sticky-wrapper').css('height', 'auto');
    }, 250);
  },
  unload: function ($section) {
    $('[data-mobilemenu-toggle]').off();
    $('.mobile-menu__toggle-icon').off();
    $('.mobile-menu .close-dropdown').off();
    this.disableSticky();
  }
};

/* option_selection.js */
function floatToString(t, e) {
  var o = t.toFixed(e).toString();
  return o.match(/^\.\d+/) ? "0" + o : o;
}
if ("undefined" == typeof Shopify) var Shopify = {};
Shopify.each = function (t, e) {
  for (var o = 0; o < t.length; o++) e(t[o], o);
}, Shopify.map = function (t, e) {
  for (var o = [], i = 0; i < t.length; i++) o.push(e(t[i], i));
  return o;
}, Shopify.arrayIncludes = function (t, e) {
  for (var o = 0; o < t.length; o++) if (t[o] == e) return !0;
  return !1;
}, Shopify.uniq = function (t) {
  for (var e = [], o = 0; o < t.length; o++) Shopify.arrayIncludes(e, t[o]) || e.push(t[o]);
  return e;
}, Shopify.isDefined = function (t) {
  return "undefined" == typeof t ? !1 : !0;
}, Shopify.getClass = function (t) {
  return Object.prototype.toString.call(t).slice(8, -1);
}, Shopify.extend = function (t, e) {
  function o() {}
  o.prototype = e.prototype, t.prototype = new o(), t.prototype.constructor = t, t.baseConstructor = e, t.superClass = e.prototype;
}, Shopify.locationSearch = function () {
  return window.location.search;
}, Shopify.locationHash = function () {
  return window.location.hash;
}, Shopify.replaceState = function (t) {
  window.history.replaceState({}, document.title, t);
}, Shopify.urlParam = function (t) {
  var e = RegExp("[?&]" + t + "=([^&#]*)").exec(Shopify.locationSearch());
  return e && decodeURIComponent(e[1].replace(/\+/g, " "));
}, Shopify.newState = function (t, e) {
  var o;
  return o = Shopify.urlParam(t) ? Shopify.locationSearch().replace(RegExp("(" + t + "=)[^&#]+"), "$1" + e) : "" === Shopify.locationSearch() ? "?" + t + "=" + e : Shopify.locationSearch() + "&" + t + "=" + e, o + Shopify.locationHash();
}, Shopify.setParam = function (t, e) {
  Shopify.replaceState(Shopify.newState(t, e));
}, Shopify.Product = function (t) {
  Shopify.isDefined(t) && this.update(t);
}, Shopify.Product.prototype.update = function (t) {
  for (let property in t) this[property] = t[property];
}, Shopify.Product.prototype.optionNames = function () {
  return "Array" == Shopify.getClass(this.options) ? this.options : [];
}, Shopify.Product.prototype.optionValues = function (t) {
  if (!Shopify.isDefined(this.variants)) return null;
  var e = Shopify.map(this.variants, function (e) {
    var o = "option" + (t + 1);
    return void 0 == e[o] ? null : e[o];
  });
  return null == e[0] ? null : Shopify.uniq(e);
}, Shopify.Product.prototype.getVariant = function (t) {
  var e = null;
  return t.length != this.options.length ? e : (Shopify.each(this.variants, function (o) {
    for (var i = !0, r = 0; r < t.length; r++) {
      var n = "option" + (r + 1);
      o[n] != t[r] && (i = !1);
    }
    return 1 == i ? void (e = o) : void 0;
  }), e);
}, Shopify.Product.prototype.getVariantById = function (t) {
  for (var e = 0; e < this.variants.length; e++) {
    var o = this.variants[e];
    if (t == o.id) return o;
  }
  return null;
}, Shopify.money_format = "${{amount}}", Shopify.formatMoney = function (t, e) {
  function o(t, e) {
    return "undefined" == typeof t ? e : t;
  }
  function i(t, e, i, r) {
    if (e = o(e, 2), i = o(i, ","), r = o(r, "."), isNaN(t) || null == t) return 0;
    t = (t / 100).toFixed(e);
    var n = t.split("."),
      a = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i),
      s = n[1] ? r + n[1] : "";
    return a + s;
  }
  "string" == typeof t && (t = t.replace(".", ""));
  var r = "",
    n = /\{\{\s*(\w+)\s*\}\}/,
    a = e || this.money_format;
  switch (a.match(n)[1]) {
    case "amount":
      r = i(t, 2);
      break;
    case "amount_no_decimals":
      r = i(t, 0);
      break;
    case "amount_with_comma_separator":
      r = i(t, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      r = i(t, 2);
      break;
    case "amount_no_decimals_with_comma_separator":
      r = i(t, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      r = i(t, 0, ".", " ");
  }
  return a.replace(n, r);
}, Shopify.OptionSelectors = function (t, e) {
  return this.selectorDivClass = "selector-wrapper", this.selectorClass = "single-option-selector", this.variantIdFieldIdSuffix = "-variant-id", this.variantIdField = null, this.historyState = null, this.selectors = [], this.domIdPrefix = t, this.product = new Shopify.Product(e.product), this.onVariantSelected = Shopify.isDefined(e.onVariantSelected) ? e.onVariantSelected : function () {}, this.replaceSelector(t), this.initDropdown(), e.enableHistoryState && (this.historyState = new Shopify.OptionSelectors.HistoryState(this)), !0;
}, Shopify.OptionSelectors.prototype.initDropdown = function () {
  var t = {
      initialLoad: !0
    },
    e = this.selectVariantFromDropdown(t);
  if (!e) {
    var o = this;
    setTimeout(function () {
      o.selectVariantFromParams(t) || o.fireOnChangeForFirstDropdown.call(o, t);
    });
  }
}, Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown = function (t) {
  this.selectors[0].element.onchange(t);
}, Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown = function (t) {
  var e = this.selectVariantFromParams(t);
  e || this.selectVariantFromDropdown(t);
}, Shopify.OptionSelectors.prototype.replaceSelector = function (t) {
  var e = document.getElementById(t),
    o = e.parentNode;
  Shopify.each(this.buildSelectors(), function (t) {
    o.insertBefore(t, e);
  }), e.style.display = "none", this.variantIdField = e;
}, Shopify.OptionSelectors.prototype.selectVariantFromDropdown = function (t) {
  var e = document.getElementById(this.domIdPrefix).querySelector("[selected]");
  if (e || (e = document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')), !e) return !1;
  var o = e.value;
  return this.selectVariant(o, t);
}, Shopify.OptionSelectors.prototype.selectVariantFromParams = function (t) {
  var e = Shopify.urlParam("variant");
  return this.selectVariant(e, t);
}, Shopify.OptionSelectors.prototype.selectVariant = function (t, e) {
  var o = this.product.getVariantById(t);
  if (null == o) return !1;
  for (var i = 0; i < this.selectors.length; i++) {
    var r = this.selectors[i].element,
      n = r.getAttribute("data-option"),
      a = o[n];
    null != a && this.optionExistInSelect(r, a) && (r.value = a);
  }
  return "undefined" != typeof jQuery ? jQuery(this.selectors[0].element).trigger("change", e) : this.selectors[0].element.onchange(e), !0;
}, Shopify.OptionSelectors.prototype.optionExistInSelect = function (t, e) {
  for (var o = 0; o < t.options.length; o++) if (t.options[o].value == e) return !0;
}, Shopify.OptionSelectors.prototype.insertSelectors = function (t, e) {
  Shopify.isDefined(e) && this.setMessageElement(e), this.domIdPrefix = "product-" + this.product.id + "-variant-selector";
  var o = document.getElementById(t);
  Shopify.each(this.buildSelectors(), function (t) {
    o.appendChild(t);
  });
}, Shopify.OptionSelectors.prototype.buildSelectors = function () {
  for (var t = 0; t < this.product.optionNames().length; t++) {
    var e = new Shopify.SingleOptionSelector(this, t, this.product.optionNames()[t], this.product.optionValues(t));
    e.element.disabled = !1, this.selectors.push(e);
  }
  var o = this.selectorDivClass,
    i = this.product.optionNames(),
    r = Shopify.map(this.selectors, function (t) {
      var e = document.createElement("div");
      if (e.setAttribute("class", o), i.length > 1) {
        var r = document.createElement("label");
        r.htmlFor = t.element.id, r.innerHTML = t.name, e.appendChild(r);
      }
      return e.appendChild(t.element), e;
    });
  return r;
}, Shopify.OptionSelectors.prototype.selectedValues = function () {
  for (var t = [], e = 0; e < this.selectors.length; e++) {
    var o = this.selectors[e].element.value;
    t.push(o);
  }
  return t;
}, Shopify.OptionSelectors.prototype.updateSelectors = function (t, e) {
  var o = this.selectedValues(),
    i = this.product.getVariant(o);
  i ? (this.variantIdField.disabled = !1, this.variantIdField.value = i.id) : this.variantIdField.disabled = !0, this.onVariantSelected(i, this, e), null != this.historyState && this.historyState.onVariantChange(i, this, e);
}, Shopify.OptionSelectorsFromDOM = function (t, e) {
  var o = e.optionNames || [],
    i = e.priceFieldExists || !0,
    r = e.delimiter || "/",
    n = this.createProductFromSelector(t, o, i, r);
  e.product = n, Shopify.OptionSelectorsFromDOM.baseConstructor.call(this, t, e);
}, Shopify.extend(Shopify.OptionSelectorsFromDOM, Shopify.OptionSelectors), Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector = function (t, e, o, i) {
  if (!Shopify.isDefined(o)) var o = !0;
  if (!Shopify.isDefined(i)) var i = "/";
  var r = document.getElementById(t),
    n = r.childNodes,
    a = (r.parentNode, e.length),
    s = [];
  Shopify.each(n, function (t, r) {
    if (1 == t.nodeType && "option" == t.tagName.toLowerCase()) {
      var n = t.innerHTML.split(new RegExp("\\s*\\" + i + "\\s*"));
      0 == e.length && (a = n.length - (o ? 1 : 0));
      var p = n.slice(0, a),
        l = o ? n[a] : "",
        c = (t.getAttribute("value"), {
          available: t.disabled ? !1 : !0,
          id: parseFloat(t.value),
          price: l,
          option1: p[0],
          option2: p[1],
          option3: p[2]
        });
      s.push(c);
    }
  });
  var p = {
    variants: s
  };
  if (0 == e.length) {
    p.options = [];
    for (var l = 0; a > l; l++) p.options[l] = "option " + (l + 1);
  } else p.options = e;
  return p;
}, Shopify.SingleOptionSelector = function (t, e, o, i) {
  this.multiSelector = t, this.values = i, this.index = e, this.name = o, this.element = document.createElement("select");
  for (var r = 0; r < i.length; r++) {
    var n = document.createElement("option");
    n.value = i[r], n.innerHTML = i[r], this.element.appendChild(n);
  }
  return this.element.setAttribute("class", this.multiSelector.selectorClass), this.element.setAttribute("data-option", "option" + (e + 1)), this.element.id = t.domIdPrefix + "-option-" + e, this.element.onchange = function (o, i) {
    i = i || {}, t.updateSelectors(e, i);
  }, !0;
}, Shopify.Image = {
  preload: function (t, e) {
    for (var o = 0; o < t.length; o++) {
      var i = t[o];
      this.loadImage(this.getSizedImageUrl(i, e));
    }
  },
  loadImage: function (t) {
    new Image().src = t;
  },
  switchImage: function (t, e, o) {
    if (t && e) {
      var i = this.imageSize(e.src),
        r = this.getSizedImageUrl(t.src, i);
      o ? o(r, t, e) : e.src = r;
    }
  },
  imageSize: function (t) {
    var e = t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);
    return null != e ? e[1] : null;
  },
  getSizedImageUrl: function (t, e) {
    if (null == e) return t;
    if ("master" == e) return this.removeProtocol(t);
    var o = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
    if (null != o) {
      var i = t.split(o[0]),
        r = o[0];
      return this.removeProtocol(i[0] + "_" + e + r);
    }
    return null;
  },
  removeProtocol: function (t) {
    return t.replace(/http(s)?:/, "");
  }
}, Shopify.OptionSelectors.HistoryState = function (t) {
  this.browserSupports() && this.register(t);
}, Shopify.OptionSelectors.HistoryState.prototype.register = function (t) {
  window.addEventListener("popstate", function (e) {
    t.selectVariantFromParamsOrDropdown({
      popStateCall: !0
    });
  });
}, Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function (t, e, o) {
  this.browserSupports() && (!t || o.initialLoad || o.popStateCall || Shopify.setParam("variant", t.id));
}, Shopify.OptionSelectors.HistoryState.prototype.browserSupports = function () {
  return window.history && window.history.replaceState;
};

/*============================================================================
Product media controls
==============================================================================*/

window.PXUTheme.productMedia = {
  models: [],
  setupMedia: function () {
    const config = {
      // Default control list
      controls: ['zoom-in', 'zoom-out', 'fullscreen'],
      focusOnPlay: false
    };
    $('model-viewer').each(function (index, model) {
      model = new Shopify.ModelViewerUI(model, config);
      window.PXUTheme.productMedia.models.push(model);
    });
    $('.product-gallery__model model-viewer').on('mousedown', function () {
      window.PXUTheme.productMedia.hideModelIcon(this);
    });
  },
  showModelIcon: function (slide) {
    $(slide).find('.button--poster, .model-icon-button-control').show();
  },
  hideModelIcon: function (slide) {
    $(slide).find('.button--poster, .model-icon-button-control').hide();
  }
};
window.PXUTheme.productReviews = {
  init: function () {
    if ($('#shopify-product-reviews').length || $('.shopify-product-reviews-badge').length) {
      SPR.$(document).ready(function () {
        return SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges();
      });
    }
  },
  productReviewScroll: function () {
    if ($('#shopify-product-reviews').length && $('.shopify-product-reviews-badge').length) {
      $('.spr-badge-container').on('click', function () {
        window.PXUTheme.scrollToTop('#shopify-product-reviews');
      });
    }
  },
  unload: function () {
    $('.spr-badge-container').off();
  }
};
window.PXUTheme.quantityBox = {
  init: function () {
    $('body').on('click', '[data-update-quantity]:not([disabled])', function () {
      window.PXUTheme.quantityBox.updateQuantity($(this));
    });
    $('body').on('keyup keydown change', '.quantity-input', function () {
      window.PXUTheme.quantityBox.updateQuantity($(this));
    });
  },
  updateQuantityControls: function ($el) {
    const $quantityBox = $el.parents('.product-quantity-box');
    const $input = $('.quantity-input', $quantityBox);
    let val = parseInt($input.val());
    let valMax = 100000000000000000;
    if ($input.attr('max') != null) {
      valMax = $input.attr('max');
    }
    if (val === 1 || val === 0) {
      $('.quantity-minus', $quantityBox).attr('disabled', true);
      $('.quantity-plus', $quantityBox).attr('disabled', false);
    } else if (val >= valMax) {
      $('.quantity-plus', $quantityBox).attr('disabled', true);
      $('.quantity-minus', $quantityBox).attr('disabled', false);
      $input.val(valMax);
    } else {
      $('.quantity-minus', $quantityBox).attr('disabled', false);
      $('.quantity-plus', $quantityBox).attr('disabled', false);
    }
  },
  updateQuantity: function ($el) {
    const $quantityBox = $el.parents('.product-quantity-box');
    const $input = $('.quantity-input', $quantityBox);
    const lineID = $quantityBox.parents('[data-line-item]').data('line-item');
    let val = parseInt($input.val());
    let valMax = 100000000000000000;
    let valMin = $input.attr('min') || 0;
    if ($input.attr('max') != null) {
      valMax = $input.attr('max');
    }
    if (val < valMin) {
      $input.val(valMin);
      return false;
    } else if (val > valMax) {
      $input.val(valMax);
      return false;
    }
    if ($el.data('update-quantity') === 'plus') {
      // Increase quantity input by one
      if (val < valMax) {
        val++;
        $input.val(val);
      }
    } else if ($el.data('update-quantity') === 'minus') {
      // Decrease quantity by one
      if (val > valMin) {
        val--;
        $input.val(val);
      }
    }

    // Update quantity if within cart (vs on the product page)
    if ($el.parents('[data-line-item]').length) {
      const lineID = $quantityBox.data('line-item-key');
      window.PXUTheme.quantityBox.updateCart(lineID, val);
    }

    // Call to update quantity controls
    window.PXUTheme.quantityBox.updateQuantityControls($el);
  },
  updateCart: function (lineID, quantity) {
    $('.quantity-warning').removeClass('animated bounceIn');
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: `quantity=${quantity}&line=${lineID}`,
      dataType: 'json',
      success: function (cart) {
        let newQuantity = 0;
        let itemsLeftText = '';
        let quantityWarning = $(`[data-line-item="${lineID}"]`).find('.quantity-warning');
        let $quantityBox = $(`[data-line-item="${lineID}"]`).find('.product-quantity-box');
        let $currentDiscount = $('.cart__form').data('currentDiscount');

        //check to see if there are correct amount of products in array
        const cartItemsLineID = lineID - 1;
        if (typeof cart.items[cartItemsLineID] !== "undefined") {
          newQuantity = cart.items[cartItemsLineID].quantity;
        }
        for (let i = 0; i < cart.items.length; i++) {
          if (i != cartItemsLineID) {
            if (cart.items[i].id == cart.items[cartItemsLineID].id) {
              newQuantity += cart.items[i].quantity;
            }
          }
        }
        if (quantity > 0 && quantity != newQuantity) {
          //Check if total discount has changed
          if (cart.total_discount <= $currentDiscount) {
            if (newQuantity == 1) {
              itemsLeftText = window.PXUTheme.translation.product_count_one;
              quantityWarning.text(`${newQuantity} ${itemsLeftText}`);
              $('.quantity-minus', $quantityBox).attr('disabled', true);
            } else {
              itemsLeftText = window.PXUTheme.translation.product_count_other;
              quantityWarning.text(`${newQuantity} ${itemsLeftText}`);
            }
          }
        }

        //Update total discount value
        $('.cart__form').data('currentDiscount', cart.total_discount);

        // Apply quantity warning
        quantityWarning.addClass('animated bounceIn');
        if (typeof window.PXUTheme.jsAjaxCart !== 'undefined') {
          window.PXUTheme.jsAjaxCart.updateView();
        }
        if (window.PXUTheme.jsCart) {
          window.PXUTheme.jsCart.updateView(cart, lineID);
        }
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  },
  unload: function ($target) {
    $('.quantity-input').off();
    $('[data-update-quantity]').off();
  }
};
window.PXUTheme.queryParameters = {};
if (location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
      window.PXUTheme.queryParameters[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}
window.PXUTheme.responsiveVideo = {
  init: function () {
    $('iframe[src*="youtube.com"]:not(.plyr__video-wrapper iframe[src*="youtube.com"], .lazyframe iframe[src*="youtube.com"])').wrap('<div class="lazyframe" data-ratio="16:9" style="height: 400px;"></div>');
    $('iframe[src*="vimeo.com"]:not(.plyr__video-wrapper iframe[src*="vimeo.com"], .lazyframe iframe[src*="vimeo.com"])').wrap('<div class="lazyframe" data-ratio="16:9"></div>');
  }
};
function selectCallback(productEl, product, variant, state) {
  const $product = $(productEl);
  const $notifyForm = $('.product__notify-form', $product);
  const $productForm = $('.product_form, .shopify-product-form', $product);
  const variantInventory = $productForm.data('variant-inventory');
  const $productFormInput = $productForm.find('.quantity-input');
  const $notifyFormInputs = $('.notify_form__inputs');
  const notifyEmail = window.PXUTheme.translation.notify_form_email;
  const notifyEmailValue = window.PXUTheme.translation.contact_email;
  const notifySend = window.PXUTheme.translation.notify_form_send;
  const notifyUrl = $notifyFormInputs.data('url');
  const selectedInput = $product[0].querySelector('input[type="radio"]:checked');
  const isAvailable = selectedInput && 
  (selectedInput.getAttribute('data-variant-option-available') === 'true' ||
    selectedInput.closest('[data-variant-option-value-wrapper]').getAttribute('data-variant-option-available') === 'true');
  let notifyMessage = '';
  let notifyEmailInput = '';
  if (variant) {
    document.dispatchEvent(new CustomEvent('variant:change', {
      detail: {
        product: product,
        variant: variant,
        state: 'selected'
      }
    }));
    if (variant.title != null) {
      // Escape variant titles
      const variantTitle = variant.title.toLowerCase() === 'default title' ? variant.name.replace(/"/g, '&quot;') : variant.title.replace(/"/g, '&quot;');
      notifyMessage = `${window.PXUTheme.translation.email_content}${variantTitle} | ${notifyUrl}?variant=${variant.id}`;
    }
  } else {
    notifyMessage = `${window.PXUTheme.translation.email_content} | ${notifyUrl}`;
  }
  if ($notifyFormInputs.hasClass('customer--true')) {
    notifyEmailInput = `<input required type="email" class="notify_email input" name="contact[email]" id="contact[email]" placeholder="${notifyEmail}" value="${window.PXUTheme.translation.customer_email}" />`;
  } else {
    notifyEmailInput = `<input required type="email" class="notify_email input" name="contact[email]" id="contact[email]" placeholder="${notifyEmail}" value="${notifyEmailValue}" />`;
  }
  const notifyFormHTML = `
    <input type="hidden" name="challenge" value="false" />
    <input type="hidden" name="contact[body]" class="notify_form_message" data-body="${notifyMessage}" value="${notifyMessage}" />
    <div class="field has-addons">
      <div class="control">
        ${notifyEmailInput}
      </div>
      <div class="control">
        <input class="action_button button" type="submit" value="${notifySend}" />
      </div>
    </div>`;

  // Image Variant feature
  if (variant && variant.featured_image && $product.is(':visible')) {
    //console.log("marco");
    const $sliders = $('.product-gallery__main, .js-gallery-modal', $product);
    $sliders.each((_index, value) => {
      const $slider = $(value);
      const $sliderInstance = window.Flickity.data(value);
     // console.log("setting the index");
      const index = $(`img[data-image-id=${variant.featured_media.id}]`).data('index');
      if ($slider.is(':visible') && $sliderInstance !== undefined) {
        $sliderInstance.select(index, false, true);
      }
    });
  }

  // Emits custom event
  const $selectDropdown = $productForm.find('[data-variant-selector]');
  $selectDropdown.trigger('selectedVariantChanged');
  $('.cart-warning', $product).text('');
  if (variant) {
    $('.sku', $product).text(variant.sku);
    $('.notify_form_message', $product).attr('value', `${$('.notify_form_message', $product).data('body')} - ${variant.title}`);
  }
  if (variant && isAvailable) {
    const variantWithInventory = {
      ...variant,
      ...(variantInventory ? variantInventory.find(v => v.id === variant.id) || {} : {})
    };
    if (variantWithInventory.inventory_management && variantWithInventory.inventory_quantity > 0) {
      if (window.PXUTheme.theme_settings.display_inventory_left) {
        let itemsLeftText = window.PXUTheme.translation.product_count_other;
        if (variantWithInventory.inventory_quantity === 1) {
          itemsLeftText = window.PXUTheme.translation.product_count_one;
        }
        const inventoryThreshold = window.PXUTheme.theme_settings.inventory_threshold;
        if (variantWithInventory.inventory_quantity <= inventoryThreshold) {
          $('.items_left', $product).html(`${variantWithInventory.inventory_quantity} ${itemsLeftText}`);
        } else {
          $('.items_left', $product).html('');
        }
      }
      if (variantWithInventory.inventory_policy === 'deny') {
        $('[data-max-inventory-management]', $product).attr('max', variantWithInventory.inventory_quantity);

        // Check to see if quantity selector should be disabled based on inventory remaining
        window.PXUTheme.quantityBox.updateQuantityControls($productFormInput);
      }
    } else {
      $('.items_left', $product).text('');
      $('[data-max-inventory-management]', $product).removeAttr('max');
    }
    $('.sold_out', $product).text('');
    //$('[data-add-to-cart-trigger]', $product).removeClass('disabled').removeAttr('disabled').attr('data-options-unselected', null).find('span:not(.icon)').text($('[data-add-to-cart-trigger]', $product).data('label'));

    // Initialize shopify payment buttons
    if (Shopify.PaymentButton) {
      Shopify.PaymentButton.init();
    }
    $('.shopify-payment-button', $product).show();
    $('.purchase-details__quantity', $product).show();
    $notifyForm.hide();
    $notifyFormInputs.empty(); 
    $notifyFormInputs.append(notifyFormHTML);
    if (window.PXUTheme.currencyConverter) {
      window.PXUTheme.currencyConverter.convertCurrencies();
    }
    
     $('a.button.action_button.kbutton.button--primary.klaviyo-bis-trigger').hide()
    
    $('[data-add-to-cart-trigger] span.text', $product).html('Add '+variant.title+' to cart')
    
  } else {
    /*const message = variant ? window.PXUTheme.translation.soldOut : window.PXUTheme.translation.unavailable;*/
    $('.items_left', $product).text('');
    $('[data-max-inventory-management]', $product).removeAttr('max');
    $('.sold_out', $product).text(message);
   // $('[data-add-to-cart-trigger]', $product).addClass('disabled').attr('disabled', 'disabled').attr('data-options-unselected', null).find('span:not(.icon)').text(message);
    $('.shopify-payment-button', $product).hide();
    $('.purchase-details__quantity', $product).hide();
    $notifyForm.hide();
    $notifyFormInputs.empty();
    if (variant && !variant.available) {
      $notifyForm.fadeIn();
      $notifyFormInputs.empty();
      $notifyFormInputs.append(notifyFormHTML);
    }

    $('a.button.action_button.kbutton.button--primary.klaviyo-bis-trigger').show()
  }
  /*$('[data-add-to-cart-trigger] span.text', $product).html('pick a size and color')*/
}
window.selectCallback = selectCallback;

/* eslint-disable */
window.PXUTheme.predictiveSearch = {
  vars: {
    term: '',
    searchResourceType: null
  },
  init: function () {
    this.unload();
    /*$('[data-show-search-trigger], [data-autocomplete-true] input').on('click', function (e) {
      console.log("target", e.target);
      
      if(e.target.getAttribute("aria-expanded") == "true"){
        console.log("aria-expanded: false");
        e.target.setAttribute("aria-expanded", "false");
      }else{
        console.log("aria-expanded: true");
        e.target.setAttribute("aria-expanded", "true");
      }


      if (!isScreenSizeLarge()) {
        e.stopPropagation();
        e.preventDefault();
        const formType = $(this).closest('form').find('[name="type"]').val();
        window.PXUTheme.predictiveSearch.showMobileSearch(formType);
      }
    });*/
    $('.search-form .search__fields input[type="text"], .search-form .field input[type="text"]').on('focus', e => {
      const dataSearchResourceType = e.target.closest('[data-search-resource-type]');
      if (dataSearchResourceType) {
        window.PXUTheme.predictiveSearch.vars.searchResourceType = dataSearchResourceType.getAttribute('data-search-resource-type');
      }

      // Set the cursor at the end of the input field for better UX,
      // otherwise it may be at the beginning of the input field when the input gets focus.
      const searchInputEl = e.target;
      const searchInputVal = searchInputEl.value.trim();
      searchInputEl.setSelectionRange(searchInputVal.length, searchInputVal.length);
      window.PXUTheme.predictiveSearch.getResults(searchInputVal, $(e.target.closest('.search-form')));
    });

    // Clicking outside makes the results disappear.
    $(document).on('click focusout', function (e) {
      if (window.PXUTheme.media_queries.large.matches) {
        const searchForm = $(e.target).parents('.search-form');
        if (searchForm.length === 0) {
          $('[data-autocomplete-true] .search__results-wrapper').hide();

          // This is for when the 'Vertical' header layout or the 'Search focus' header layout is in use,
          // since unlockBodyScroll won't get called in jsHeader.
          if ((window.PXUTheme.theme_settings.header_layout === 'vertical' || window.PXUTheme.theme_settings.header_layout === 'search_focus') && document.documentElement.classList.contains('scroll-locked')) {
            window.PXUTheme.predictiveSearch.unlockBodyScroll();
          }
        }
      }
    });
    $("[data-autocomplete-true] form").on("submit", function (e) {
      const query = $(this).find('input[name="q"]').val().trim();
      if (!query) e.preventDefault();
    });
    $('[data-autocomplete-true] form').each(function () {
      const $this = $(this);
      const input = $this.find('input[name="q"]');
      const resultWrapper = `<div class="search__results-wrapper"></div>`;
      $(resultWrapper).appendTo($this);
      input.attr('autocomplete', 'off').on('input', window.PXUTheme.debounce(() => {
        window.PXUTheme.predictiveSearch.vars.term = this.querySelector('[data-q]').value.trim();
        window.PXUTheme.predictiveSearch.getResults(window.PXUTheme.predictiveSearch.vars.term, $this);
      }, 200));
    });
    window.addEventListener('resize', window.PXUTheme.debounce(() => {
      if (window.PXUTheme.jsHeader.header_layout === 'vertical') {
        window.PXUTheme.predictiveSearch.alignVerticalSearch();
      }
      this.resizeSearchResults();
    }, 150));
    document.body.addEventListener('keyup', e => this.onKeyUp(e));
  },
  onKeyUp: function (e) {
    if (e.code === 'Escape') {
      $('[data-q]').val('');
      window.PXUTheme.predictiveSearch.vars.term = '';
      window.PXUTheme.jsHeader.hideSearch();
    }
  },
  resizeSearchResults: function () {
    let inputFieldEl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.querySelector('[data-autocomplete-true]');
    const innerHeight = window.innerHeight;
    const inputFieldElBottom = inputFieldEl.getBoundingClientRect().bottom;
    const offset = isScreenSizeLarge() ? 30 : 10;
    const resultsMaxHeight = `${innerHeight - inputFieldElBottom - offset}px`;
    const resultsContainerEl = inputFieldEl.closest('[data-autocomplete-true]').querySelector('.search__results-wrapper');
    resultsContainerEl.style.setProperty('--results-max-height', resultsMaxHeight);
  },
  getResults: function (term, $this) {
    const {
      header_layout
    } = window.PXUTheme.theme_settings;
    if (term.length === 0) {
      if (header_layout === 'vertical' || header_layout === 'search_focus') {
        window.PXUTheme.predictiveSearch.unlockBodyScroll();
      }
      window.PXUTheme.predictiveSearch.clearResults();
      return;
    }
    const {
      searchResourceType
    } = window.PXUTheme.predictiveSearch.vars;
    const restrictResourceCondition = searchResourceType && 'searchResourceType' in $this[0].dataset;
    fetch(`${window.PXUTheme.routes.predictive_search_url}?q=${encodeURIComponent(term)}&section_id=predictive-search${restrictResourceCondition ? `&resources[type]=${searchResourceType}` : ''}`).then(response => {
      if (!response.ok) {
        throw new Error(response.status);
      }
      return response.text();
    }).then(text => {
      window.PXUTheme.predictiveSearch.displayResults(text, $this);

      // This is for when the 'Vertical' header layout or the 'Search focus' header layout is in use,
      // since lockBodyScroll won't get called in jsHeader (due to the search icon trigger not being present).
      // lockBodyScroll has to be called here so the overlay appears at about the same time as the results.
      if ((header_layout === 'vertical' || header_layout === 'search_focus') && $this.closest('.jsHeader').length > 0) {
        window.PXUTheme.predictiveSearch.lockBodyScroll();
      }
    }).catch(error => {
      throw error;
    });
  },
  displayResults: function (results, $this) {
    const $fields = $this.find('.search__fields');
    const $resultsWrapper = $this.find('.search__results-wrapper');
    $resultsWrapper.show();
    $resultsWrapper.empty();
    $resultsWrapper.append(results);
    const inputFieldEls = $fields.length > 0 ? Array.from($fields) : document.querySelectorAll('[data-autocomplete-true]');

    // Calculate resultsWrapper max height for header search (exclude blog sidebar)
    inputFieldEls.forEach(el => {
      if (el.closest('.search-popup__form') || el.closest('.mobile-search')) {
        this.resizeSearchResults(el);
      }
    });
    if ($this.parents('.vertical-header__content').length && window.PXUTheme.jsHeader.header_layout === 'vertical') {
      window.PXUTheme.predictiveSearch.alignVerticalSearch();
    }
  },
  clearResults: function () {
    const wrapperEls = document.querySelectorAll('.search-form .search__results-wrapper');
    wrapperEls.forEach(el => {
      // This should be more performant than `innerHTMl = ""`
      while (el.firstChild) el.removeChild(el.firstChild);
    });
  },
  showMobileSearch: function (formType) {
    let position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    $('body').css('max-height', window.innerHeight);
    $('.mobile-search').fadeIn(200);
    if (/iPad|iPhone|iPod/.test(navigator.platform) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
      $('.mobile-search input[data-q]').focus();
    } else {
      //Set delay to ensure focus triggers on android
      setTimeout(function () {
        $('.mobile-search input[data-q]').focus();
      }, 205);
    }
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + position + 'px';
    $('.mobile-search').css('top', position);
    if (formType) {
      $('.mobile-search [name="type"]').val(formType);
    }
    $('.search-form .close-search').on('click touchstart', function (e) {
      e.preventDefault();
      e.stopPropagation();
      window.PXUTheme.predictiveSearch.hideMobileSearch(position);
      $('[data-autocomplete-true] .search__results-wrapper').hide();
    });
    $('.search-form .submit-search').on('click touchstart', function (e) {
      $(this).parents('form').submit();
    });
    document.addEventListener('click', e => {
      if (!e.target.closest('.search-form')) {
        window.PXUTheme.predictiveSearch.hideMobileSearch();
      }
    });
  },
  hideMobileSearch: function () {
    let position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    $('body').css('max-height', 'none');
    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo(0, position);
    $('.mobile-search').fadeOut(200);
    $('body').off('focus', '.search-form .close-search');
    $('body').off('focus', '.search-form .submit-search');
    window.PXUTheme.predictiveSearch.unlockBodyScroll();
  },
  lockBodyScroll: function () {
    document.documentElement.classList.add('scroll-locked');
    document.querySelector('[data-site-overlay]').classList.remove('site-overlay--hidden');
  },
  unlockBodyScroll: function () {
    document.documentElement.classList.remove('scroll-locked');
    document.querySelector('[data-site-overlay]').classList.add('site-overlay--hidden');
  },
  alignVerticalSearch: function () {
    const $resultsList = $('.header--vertical .search__results');
    const headerWidth = $('.header--vertical').innerWidth();
    $resultsList.parents('.search__results-wrapper').css({
      'position': 'fixed',
      'left': headerWidth,
      'top': '0'
    });
  },
  unload: function () {
    $('body').off('focus', '[data-autocomplete-true] input');
    $('input[name="q"]').off();
    $('[data-dropdown-rel="search"], [data-autocomplete-true] input').off();
    $('.search__results-wrapper').remove();
  }
};
function isScreenSizeLarge() {
  if (window.PXUTheme.media_queries.large.matches) {
    return true;
  }
}
window.PXUTheme.scrollToTop = function (element, height) {
  // Check if height argument is present
  if (height != undefined) {
    $('html, body').animate({
      scrollTop: $(element).offset().top - height
    }, 1000);
  } else {
    $('html, body').animate({
      scrollTop: $(element).offset().top
    }, 1000);
  }
};


window.PXUTheme.tabs = {
  enableTabs: function () {
    let $tabs = $('.tabs li, .tabs li a');
    $tabs.on('click', function (el) {
      el.preventDefault();

      // toggle active tab
      $tabs.removeClass('is-active active');
      $(this).addClass('is-active');
      let $tabIndex = $(this).index();
      let $tabContent = $(this).parents('.tabs').next('.tabs-content');

      // toggle corresponding tab content
      $tabContent.children('li, li a').removeClass('is-active active');
      $tabContent.children('li, li a').eq($tabIndex).addClass('is-active').show().css({
        'display': 'block'
      }).siblings().hide().removeClass('is-active');
    });
  },
  unload: function () {
    $('.tabs li, .tabs li a').off();
  }
};
// Enhanced ProductCard class with real-time updates
class ProductCard { 
  constructor() {
    this.cachedBrownMetafield = null;
    this.metafieldCacheExpiry = null;
    this.CACHE_DURATION = 5 * 60 * 1000; // 5 minutes
    
    // Flag to prevent interference during filter processing
    this.isFilterProcessing = false;
    
    // Initialize filter change listeners
    this.initFilterChangeListeners();
  }

  initFilterChangeListeners() {
    // Listen for the simplified filter system's custom events
    document.addEventListener('filterProcessingStart', () => {
      this.isFilterProcessing = true;
      //console.log('ProductCard: Filter processing started');
    });
    
    document.addEventListener('filterProcessingComplete', () => {
      this.isFilterProcessing = false;
      //console.log('ProductCard: Filter processing completed');
      // Handle filter change after processing is complete
      setTimeout(() => {
        this.handleFilterChange();
      }, 0);
    });

    // Listen for filter form submissions (fallback)
    $(document).on('submit', '.faceted-filter-form', (e) => {
      e.preventDefault(); // This should already be handled by main script
      setTimeout(() => {
        this.handleFilterChange();
      }, 0);
    });

    // Listen for filter pill/tag removals (fallback)
    $(document).on('click', '.faceted-active-filters__remove-filter', () => {
      setTimeout(() => {
        this.handleFilterChange();
      }, 0);
    });

    // Listen for URL changes (browser back/forward)
    window.addEventListener('popstate', () => {
      this.handleFilterChange();
    });
  }

  // Handle filter changes (simplified)
  handleFilterChange() {
    // Don't process if filter system is currently processing
    if (this.isFilterProcessing) {
      console.log('Filter system is processing, skipping ProductCard updates');
      return;
    }
    
    //console.log('ProductCard: Handling filter change');
    
    // Update product images based on new filters
    this.initializeImagesFromFilters();
    
    // Refresh the load more button
    this.refreshLoadMoreButton();
    
    // Update breadcrumbs if needed
    this.updateBreadcrumbs();
  }

  // Method to be called directly by the filter system
  initializeImagesFromFilters() {
    const activeColors = this.getActiveColorFilters();
    
    if (activeColors.length > 0) {
      this.updateAllThumbnailsFromFilters(activeColors);
    } else {
      // Reset all images to original if no color filters
      this.resetAllThumbnailsToOriginal();
    }
  }

  // Get active color filters from current DOM state
  getActiveColorFilters() {
    const activeColors = [];
    
    // Method 1: Check URL parameters for color filters
    const urlParams = new URLSearchParams(window.location.search);
    const colorFilterParams = ['filter.v.option.color', 'color', 'Color', 'colour', 'Colour'];
    
    colorFilterParams.forEach(param => {
      const values = urlParams.getAll(param);
      if (values.length > 0) {
        activeColors.push(...values);
      }
    });
    
    // Method 2: Check checked checkboxes in the filter form
    $('.faceted-filter-group-display__list-item-input:checked:not(:disabled)').each(function() {
      const $checkbox = $(this);
      const filterLabel = $checkbox.closest('.accordion-item').find('.filter_accordion-header span').text().trim().toLowerCase();
      
      if (filterLabel.includes('color') || filterLabel.includes('colour')) {
        const colorValue = $checkbox.siblings('.faceted-filter-group-display__list-item-label-text').text().trim();
        if (colorValue && !activeColors.includes(colorValue)) {
          activeColors.push(colorValue);
        }
      }
    });
    
    // Method 3: Check active filter pills/tags
    $('.faceted-active-filters__remove-filter').each(function() {
      const filterText = $(this).find('span').text().trim();
      if (filterText && !activeColors.some(color => filterText.toLowerCase().includes(color.toLowerCase()))) {
        activeColors.push(filterText);
      }
    });
    
    //console.log('Active colors found:', [...new Set(activeColors)]);
    return [...new Set(activeColors)];
  }

  refreshLoadMoreButton() {
    //console.log("***************refreshing the Load more button*************");
    const $loadMoreButton = $('.js-load-more-button, [data-load-more-infinite], .load-more-button');
    const $paginationContainer = $('.paginate, [data-paginate]');
    //console.log("Load more button length:", $loadMoreButton.length);
    //console.log("Pagination container length:", $paginationContainer.length);
    
    if ($loadMoreButton.length === 0) {
      console.log("No load more button found, but continuing to determine pagination state");
    }
    
    // Get current page from URL (most reliable source)
    const urlParams = new URLSearchParams(window.location.search);
    let currentPage = parseInt(urlParams.get('page')) || 1;
    let totalPages = 1;
    
    // Method 1: Calculate total pages based on actual product count and results text
    const $productGrid = $('.collection__main');
    const $products = $productGrid.find('.ProductIdentifier');
    const productsPerPage = 20; // Adjust based on your settings
    
    console.log(`Products currently displayed: ${$products.length}`);
    
    // Look for result count indicators in various formats
    const resultSelectors = [
      '.desktopCount'
    ];
    
    let $resultCount = null;
    let totalProducts = 0;
    let showingCount = 0;
    
    for (const selector of resultSelectors) {
      $resultCount = $(selector);
      if ($resultCount.length > 0) {
        const countText = $resultCount.text().toLowerCase();
        //console.log(`Found result count element: "${countText}"`);
        
        // Try various text patterns
        const patterns = [
          /showing\s+(\d+)\s*-?\s*(\d+)\s+of\s+(\d+)/i,  // "Showing 1-20 of 45"
          /(\d+)\s*-?\s*(\d+)\s+of\s+(\d+)/i,            // "1-20 of 45"
          /showing\s+(\d+)\s+of\s+(\d+)/i,               // "Showing 20 of 45"
          /(\d+)\s+of\s+(\d+)/i,                         // "20 of 45"
          /(\d+)\s+results?/i                            // "45 results"
        ];
        
        for (const pattern of patterns) {
          const match = countText.match(pattern);
          if (match) {
            if (match.length === 4) {
              // Pattern with start-end-total
              showingCount = parseInt(match[2]);
              totalProducts = parseInt(match[3]);
            } else if (match.length === 3) {
              // Pattern with showing-total
              showingCount = parseInt(match[1]);
              totalProducts = parseInt(match[2]);
            } else if (match.length === 2) {
              // Pattern with just total
              totalProducts = parseInt(match[1]);
              showingCount = $products.length;
            }
            
            if (totalProducts > 0) {
              totalPages = Math.ceil(totalProducts / productsPerPage);
              //console.log(`Calculated from result text: ${totalProducts} total products, ${totalPages} total pages`);
              break;
            }
          }
        }
        
        if (totalProducts > 0) break;
      }
    }
    
    // Method 2: If no result count found, check pagination DOM elements
    if (totalPages === 1 && $paginationContainer.length > 0) {
      // Look for pagination links
      const $pageLinks = $paginationContainer.find('a, span').filter(function() {
        const text = $(this).text().trim();
        return /^\d+$/.test(text);
      });
      
      if ($pageLinks.length > 0) {
        const pageNumbers = $pageLinks.map(function() {
          return parseInt($(this).text());
        }).get().filter(num => !isNaN(num));
        
        if (pageNumbers.length > 0) {
          totalPages = Math.max(...pageNumbers);
          console.log(`Calculated from pagination links: ${totalPages} total pages`);
        }
      }
      
      // Also check data attributes as backup
      const dataPages = parseInt(
        $paginationContainer.data('paginate-pages') || 
        $paginationContainer.data('total-pages') || 
        $paginationContainer.attr('data-paginate-pages') || 
        1
      );
      
      if (dataPages > totalPages) {
        totalPages = dataPages;
        //console.log(`Used data attribute: ${totalPages} total pages`);
      }
    }
    
    // Method 3: Smart estimation based on current results
    if (totalPages === 1) {
      // If we have exactly the products per page count, there might be more
      if ($products.length === productsPerPage) {
        totalPages = currentPage + 1; // Assume at least one more page
        console.log(`Estimated based on full page: assuming page ${currentPage + 1} exists`);
      } else if ($products.length > 0 && $products.length < productsPerPage && currentPage === 1) {
        totalPages = 1; // Less than full page on page 1 = only 1 page
        console.log(`Confirmed single page: ${$products.length} products < ${productsPerPage} per page`);
      }
    }
    
    // Method 4: Check if there's actually a next page by looking at the current URL structure
    // This is useful when filtering might change the total pages
    if (totalPages > 1) {
      // If we're on page 1 and showing less than productsPerPage items, we probably don't have more pages
      if (currentPage === 1 && $products.length < productsPerPage && $products.length > 0) {
        totalPages = 1;
        //console.log(`Corrected to single page: first page shows ${$products.length} < ${productsPerPage} products`);
      }
    }
    
    //console.log(`Final calculation: Current page: ${currentPage}, Total pages: ${totalPages}`);
    //console.log(`Products displayed: ${$products.length}, Products per page: ${productsPerPage}`);
    
    // Update pagination container with correct data
    if ($paginationContainer.length > 0) {
      $paginationContainer.data('current-page', currentPage);
      $paginationContainer.data('paginate-pages', totalPages);
      $paginationContainer.attr('data-current-page', currentPage);
      $paginationContainer.attr('data-paginate-pages', totalPages);
    }
    
    // Handle load more button visibility
    if (currentPage >= totalPages || totalPages === 1) {
      if ($loadMoreButton.length > 0) {
        $loadMoreButton.hide();
        // console.log('✓ Load more button HIDDEN - on last page or single page');
      } else {
        // console.log('✓ Load more button should be HIDDEN but element not found');
      }
    } else {
      if ($loadMoreButton.length > 0) {
        $loadMoreButton.show();
        this.updateLoadMoreUrl($loadMoreButton, currentPage + 1);
        // console.log('✓ Load more button SHOWN - more pages available');
      } else {
        // console.log('✗ Load more button should be SHOWN but element not found');
      }
    }
    
    // Additional debugging info
    // console.log('=== DEBUGGING INFO ===');
    // console.log('URL params:', Object.fromEntries(urlParams));
      // console.log('Pagination container data:', {
      //   'data-current-page': $paginationContainer.data('current-page'),
      //   'data-paginate-pages': $paginationContainer.data('paginate-pages')
      // });
    // console.log('Load more button state:', {
      //   'exists': $loadMoreButton.length > 0,
      //   'visible': $loadMoreButton.length > 0 ? $loadMoreButton.is(':visible') : false,
      //   'display': $loadMoreButton.length > 0 ? $loadMoreButton.css('display') : 'N/A'
      // });
    // console.log('======================');
  }

  onCollectionUpdate() {
    // console.log('Collection updated, refreshing components');
    this.initFilterChangeListeners();
    this.handleFilterChange();
  }

  updateBreadcrumbs() {
    const $paginationContainer = $('.paginate, [data-paginate]');
    
    if ($paginationContainer.length > 0) {
      const currentPage = parseInt($paginationContainer.data('current-page') || 1);
      const totalPages = parseInt($paginationContainer.data('paginate-pages') || 1);
      
      if (window.PXUTheme && window.PXUTheme.breadcrumbs) {
        window.PXUTheme.breadcrumbs.init(totalPages);
      }
    }
  }

  updateLoadMoreUrl($button, nextPage) {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('page', nextPage);
    
    if ($button.is('a')) {
      $button.attr('href', currentUrl.toString());
    } else if ($button.data('url')) {
      $button.data('url', currentUrl.toString());
    }
    
    $button.attr('data-page', nextPage);
    // console.log(`Updated load more URL to: ${currentUrl.toString()}`);
  }

  enableSwatches() {
    // console.log("Enabling swatches");
    this.initializeImagesFromFilters();
    
    if (window.isScreenSizeLarge()) {
      $('body').on('mouseenter', '.swatch span', (e) => {
        const currentTarget = e.currentTarget;
        // console.log("Swatch hover enter");
        
        if ($(currentTarget).data('image') && $(currentTarget).data('image').indexOf('no-image') === -1) {
          $(currentTarget).parents('.thumbnail').find('.product__imageContainer img:not(.secondary)').attr('src', $(currentTarget).data('image'));
          $(currentTarget).parents('.thumbnail').find('.product__imageContainer img:not(.secondary)').attr('srcset', $(currentTarget).data('image'));
        }
      });
      
      $('body').on('mouseleave', '.thumbnail', (e) => {
        setTimeout(() => {
          this.updateSingleThumbnailFromFilters($(e.currentTarget));
        }, 100);
      });
    }
  }

  showVariantImage() {
    // console.log("Setting up variant image swap");
    
    $('body').off('mouseenter.variantImage mouseleave.variantImage', '.has-secondary-image-swap');
    
    $('body').on('mouseenter.variantImage', '.has-secondary-image-swap', function() {
      // console.log("Variant image hover enter");
      const $container = $(this);
      const $primaryImage = $container.find('img:not(.secondary)');
      const $secondaryImage = $container.find('img.secondary');
      
      $primaryImage.toggleClass('swap--visible');
      $secondaryImage.toggleClass('swap--visible');
    });

    $('body').on('mouseleave.variantImage', '.has-secondary-image-swap', function() {
      // console.log("Variant image hover leave");
      const $container = $(this);
      const $primaryImage = $container.find('img:not(.secondary)');
      const $secondaryImage = $container.find('img.secondary');
      
      $primaryImage.toggleClass('swap--visible');
      $secondaryImage.toggleClass('swap--visible');
    });
  }

  updateAllThumbnailsFromFilters(activeColors = null) {
    if (!activeColors) {
      activeColors = this.getActiveColorFilters();
    }
    
    $('.thumbnail').each((index, element) => {
      this.updateSingleThumbnailFromFilters($(element), activeColors);
    });
  }

  // Get metafield data from window object (set via Liquid template)
  getShopMetafield(key) {
    return window.shopMetafields?.[key] || null;
  }

  // Extract all color names from MetaObject entries
  extractColorNamesFromMetaObject(metafieldData, fieldkeyName) {
    const colorNames = [];
    
    if (!metafieldData) {
      return colorNames;
    }
    
    // Handle simple colorNames array (Option 3 from Liquid template)
    if (metafieldData.colorNames && Array.isArray(metafieldData.colorNames)) {
      return metafieldData.colorNames.filter(name => name && name.trim());
    }
    
    // Handle entries array (Option 2 from Liquid template)
    if (metafieldData.entries && Array.isArray(metafieldData.entries)) {
      metafieldData.entries.forEach(entry => {
        if (entry && entry.fields) {
          const colorNameField = entry.fields.find(field => 
            field.key === fieldkeyName || field.key === 'color_name'
          );
          
          if (colorNameField && colorNameField.value && colorNameField.value.trim()) {
            colorNames.push(colorNameField.value.trim());
          }
        }
      });
    }
    
    // Handle references array (Option 1 from Liquid template)
    if (metafieldData.references && Array.isArray(metafieldData.references)) {
      metafieldData.references.forEach(entry => {
        if (entry && entry.fields) {
          const colorNameField = entry.fields.find(field => 
            field.key === fieldkeyName || field.key === 'color_name'
          );
          
          if (colorNameField && colorNameField.value && colorNameField.value.trim()) {
            colorNames.push(colorNameField.value.trim());
          }
        }
      });
    }
    
    // Handle case where reference is a single metaobject entry
    if (metafieldData.reference && metafieldData.reference.fields) {
      const colorNameField = metafieldData.reference.fields.find(field => 
        field.key === fieldkeyName || field.key === 'color_name'
      );
      
      if (colorNameField && colorNameField.value && colorNameField.value.trim()) {
        colorNames.push(colorNameField.value.trim());
      }
    }
    
    // Handle case where value is an array of references (list of metaobjects)
    if (metafieldData.value && Array.isArray(metafieldData.value)) {
      metafieldData.value.forEach(entry => {
        if (entry && entry.fields) {
          const colorNameField = entry.fields.find(field => 
            field.key === fieldkeyName || field.key === 'color_name'
          );
          
          if (colorNameField && colorNameField.value && colorNameField.value.trim()) {
            colorNames.push(colorNameField.value.trim());
          }
        }
      });
    }
    
    // console.log('Extracted color names from MetaObject entries:', colorNames);
    return [...new Set(colorNames)]; // Remove duplicates
  }

  // Get color metafield and key based on active color
  getColorMetafieldInfo(activeColor) {
    const colorLower = activeColor.toLowerCase();
    
    switch (colorLower) {
      case 'olive':
        return {
          metafield: window.shopMetafields?.olive,
          key: 'color_olive.color_name'
        };
      case 'burgundy':
        return {
          metafield: window.shopMetafields?.burgundy,
          key: 'color_burgundy.color_name'
        };
      case 'brown':
        return {
          metafield: window.shopMetafields?.brown,
          key: 'color_brown.color_name'
        };
      case 'grey':
      case 'gray': // Handle both spellings
        return {
          metafield: window.shopMetafields?.grey,
          key: 'color_grey.color_name'
        };
      case 'black':
        return {
          metafield: window.shopMetafields?.black,
          key: 'color_black.color_name'
        };
      default:
        return null;
    }
  }

  updateSingleThumbnailFromFilters($thumbnail, activeColors = null) {
    if (!activeColors) {
      activeColors = this.getActiveColorFilters();
    }
    
    const $primaryImg = $thumbnail.find('.product__imageContainer img:not(.secondary)');
    const $thumbnailLinks = $thumbnail.find('a[href*="/products/"]'); // Find all product links in thumbnail
    
    // Store original image source and links if not already stored
    if (!$primaryImg.data('original-src')) {
      $primaryImg.data('original-src', $primaryImg.attr('src'));
    }
    
    // Store original links if not already stored
    if (!$thumbnail.data('original-links-stored')) {
      $thumbnailLinks.each(function() {
        const $link = $(this);
        if (!$link.data('original-href')) {
          $link.data('original-href', $link.attr('href'));
        }
      });
      $thumbnail.data('original-links-stored', true);
    }
    
    if (activeColors.length === 0) {
      // Reset to original image and links if no active color filters
      const originalSrc = $primaryImg.data('original-src');
      if (originalSrc) {
        $primaryImg.attr('src', originalSrc);
        $primaryImg.attr('srcset', originalSrc);
      }
      
      // Reset all links to original URLs
      $thumbnailLinks.each(function() {
        // console.log("Resetting link to original");
        const $link = $(this);
        const originalHref = $link.data('original-href');
        if (originalHref) {
          $link.attr('href', originalHref);
        }
      });
      return;
    }
    
    // Find matching swatch for active color
    let matchingImage = null;
    let variantId = null;
    let matchingSwatch = null;
    
    for (const activeColor of activeColors) {
      // Get color metafield info for this active color
      const colorInfo = this.getColorMetafieldInfo(activeColor);
      
      const swatches = $thumbnail.find('.swatch span').get();
      let validSwatch = null;
      
      for (const swatchElement of swatches) {
        const $swatch = $(swatchElement);
        const swatchName = $swatch.parent().data('swatch-name') || '';
        const swatchImage = $swatch.data('image');
        
        // Check basic conditions first
        const hasValidImage = swatchImage && swatchImage.indexOf('no-image') === -1;
        
        let isAllowedByMetaObject = true;
        
        // Check against metafield if we have color info for this active color
        if (colorInfo && colorInfo.metafield) {
          // Extract color names from the MetaObject entries
          const colorNames = this.extractColorNamesFromMetaObject(colorInfo.metafield, colorInfo.key);
          
          if (colorNames.length > 0) {
            // Check if swatch matches any of the MetaObject color names
            isAllowedByMetaObject = colorNames.some(colorName => {
              const matches = swatchName.toLowerCase().includes(colorName.toLowerCase()) ||
                              colorName.toLowerCase().includes(swatchName.toLowerCase());
              return matches;
            });
          } else {
            console.log(`No color names found in ${activeColor} MetaObject, allowing swatch`);
          }
        }
        
        const matchesColor = swatchName.toLowerCase().includes(activeColor.toLowerCase()) ||
                           $swatch.closest('.swatch').find('span').text().toLowerCase().includes(activeColor.toLowerCase()) ||
                           swatchName.includes(activeColor.replace(/\s+/g, '_').toLowerCase());
        
        // For colors with metafields, we need both color match AND metafield approval
        // For colors without metafields, we just need color match
        if (hasValidImage) {
          if (colorInfo && colorInfo.metafield) {
            // Color has a metafield - must be approved by metafield
            if (isAllowedByMetaObject) {
              validSwatch = $swatch;
              break;
            }
          } else {
            // Color doesn't have a metafield - use regular color matching
            if (matchesColor) {
              validSwatch = $swatch;
              break;
            }
          }
        }
      }
      
      if (validSwatch) {
        matchingSwatch = validSwatch;
        matchingImage = validSwatch.data('image');
        
        // Extract variant ID from the swatch's parent link href
        const $swatchParent = validSwatch.parent();
        let swatchHref = '';
        
        if ($swatchParent.is('a')) {
          swatchHref = $swatchParent.attr('href');
        } else {
          const $swatchLink = validSwatch.closest('a');
          if ($swatchLink.length > 0) {
            swatchHref = $swatchLink.attr('href');
          }
        }
        
        // Extract variant ID from the href (format: /products/product-name?variant=123456)
        if (swatchHref) {
          const variantMatch = swatchHref.match(/[?&]variant=([^&]+)/);
          if (variantMatch) {
            variantId = variantMatch[1];
          }
        }
        
        break;
      }
    }
    
    // Update the primary image and links
    if (matchingImage) {
      //console.log("Updating image and links for color filter");
      $primaryImg.attr('src', matchingImage);
      $primaryImg.attr('srcset', matchingImage);
      
      // Update all product links to include the variant parameter
      if (variantId) {
        $thumbnailLinks.each(function() {
          const $link = $(this);
          const originalHref = $link.data('original-href');
          
          if (originalHref) {
            // Add variant parameter to the original URL
            const separator = originalHref.includes('?') ? '&' : '?';
            const newHref = `${originalHref}${separator}variant=${variantId}`;
            $link.attr('href', newHref);
          }
        });
      } else {
        console.warn('No variant ID found, keeping original links');
      }
    } else {
      // Fallback to original image and links if no matching swatch found
      const originalSrc = $primaryImg.data('original-src');
      if (originalSrc) {
        $primaryImg.attr('src', originalSrc);
        $primaryImg.attr('srcset', originalSrc);
      }
      
      // Keep original links as fallback - don't reset them
      // This allows users to still navigate to products even if no color match is found
    }
  }

  resetAllThumbnailsToOriginal() {
    $('.thumbnail').each(function() {
      const $thumbnail = $(this);
      const $primaryImg = $thumbnail.find('.product__imageContainer img:not(.secondary)');
      const $thumbnailLinks = $thumbnail.find('a[href*="/products/"]');
      
      // Reset image
      const originalSrc = $primaryImg.data('original-src');
      if (originalSrc) {
        $primaryImg.attr('src', originalSrc);
        $primaryImg.attr('srcset', originalSrc);
      }
      
      // Reset links
      $thumbnailLinks.each(function() {
        const $link = $(this);
        const originalHref = $link.data('original-href');
        if (originalHref) {
          $link.attr('href', originalHref);
        }
      });
    });
  }
}

  /* Call this method when filters are updated (integrate with your existing filter change handlers)
  onFilterChange() {
    // Small delay to ensure DOM is updated
    setTimeout(() => {
      this.initializeImagesFromFilters();
    }, 100);
  }
}*/

// Initialize ProductCard instance globally so it can be accessed by filter functions
let productCard;

// Enhanced integration with your existing filter system
document.addEventListener('DOMContentLoaded', () => {
  productCard = new ProductCard();
  productCard.enableSwatches();
  
  // Hook into your existing filter change system
  // Add this to your handleCheckboxChange function or wherever filters are processed
  const originalHandleCheckboxChange = window.handleCheckboxChange;
  if (typeof originalHandleCheckboxChange === 'function') {
    window.handleCheckboxChange = function(e) {
      const result = originalHandleCheckboxChange.call(this, e);
      // Update images after filter change
      productCard.onFilterChange();
      return result;
    };
  }
  
  // Also hook into the removefilter function
  const originalRemoveFilter = window.removefilter;
  if (typeof originalRemoveFilter === 'function') {
    window.removefilter = function(e) {
      const result = originalRemoveFilter.call(this, e);
      // Update images after filter removal
      productCard.onFilterChange();
      return result;
    };
  }
});
window.PXUTheme.thumbnail = new ProductCard();
const videoEl = {
  playButtonIcon: '<button type="button" class="plyr__control plyr__control--overlaid" aria-label="Play, {title}" data-plyr="play"><svg class="play-icon-button-control" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="60" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M23 20V40L39 29.4248L23 20Z" fill="#323232"/></svg><span class="plyr__sr-only">Play</span></button>',
  playButton: '<button type="button" class="plyr__controls__item plyr__control" aria-label="Play, {title}" data-plyr="play"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-pause"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-play"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Pause</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span></button>',
  muteButton: '<button type="button" class="plyr__controls__item plyr__control" aria-label="Mute" data-plyr="mute"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-muted"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-volume"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Unmute</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Mute</span></button>',
  progressInput: '<div class="plyr__controls__item plyr__progress__container"><div class="plyr__progress"><input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek"><progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress><span role="tooltip" class="plyr__tooltip">00:00</span></div></div>',
  volume: '<div class="plyr__controls__item plyr__volume"><input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="Volume"></div>',
  fullscreen: '<button type="button" class="plyr__controls__item plyr__control" data-plyr="fullscreen"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-exit-fullscreen"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-enter-fullscreen"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Exit fullscreen</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Enter fullscreen</span></button>'
};
const videoControls = `${videoEl.playButtonIcon}<div class="plyr__controls"> ${videoEl.playButton} ${videoEl.progressInput} ${videoEl.muteButton} ${videoEl.volume} ${videoEl.fullscreen}</div>`;
let videoPlayers = [];
let videosInRecommendedProductsPlayer;
window.PXUTheme.video = {
  init: function () {
    this.setupVideoPlayer();
  },
  setupVideoPlayer: function () {
    const productVideos = document.querySelectorAll('[data-html5-video] video, [data-youtube-video]');
    let setupVideoPlayers = Plyr.setup(productVideos, {
      controls: videoControls,
      ratio: this.aspect_ratio,
      fullscreen: {
        enabled: true,
        fallback: true,
        iosNative: true
      },
      storage: {
        enabled: false
      }
    });
    let videoLooping = $('[data-video-loop]').data('video-loop') || false;
    $.each(setupVideoPlayers, function (index, player) {
      player.loop = videoLooping;
      videoPlayers.push(player);
    });
    this.setupListeners();
  },
  setupListeners: function () {
    // Adds plyr video id to video wrapper
    $.each(videoPlayers, function (index, player) {
      const id = player.id;
      let $video;
      if (player.isHTML5) {
        $video = $(player.elements.wrapper).find('video');
        $video.attr('data-plyr-video-id', id);
      }

      // When a video is playing, pause any other instances
      player.on('play', function (event) {
        var instance = event.detail.plyr;
        $.each(videoPlayers, function (index, player) {
          var playerID = player.id || player.media.dataset.plyrVideoId;
          if (instance.id != playerID) {
            player.pause();
          }
        });
      });
    });
  },
  enableVideoOnHover: function ($thumbnail) {
    var $html5Video = $thumbnail.find('[data-html5-video]');
    var $youtubeVideo = $thumbnail.find('[data-youtube-video]');
    var videoID;
    if ($html5Video.length > 0) {
      videoID = $html5Video.find('[data-plyr-video-id]').data('plyr-video-id');
    } else if ($youtubeVideo.length > 0) {
      videoID = $youtubeVideo.find('iframe').attr('id');
    }
    if (videoID) {
      $.each(videoPlayers, function (index, player) {
        if (player.id == videoID || player.media.id == videoID) {
          player.toggleControls(false);
          player.muted = true;
          player.play();
        }
      });
    }
  },
  disableVideoOnHover: function ($thumbnail) {
    var $html5Video = $thumbnail.find('[data-html5-video]');
    var $youtubeVideo = $thumbnail.find('[data-youtube-video]');
    var videoID;
    if ($html5Video.length > 0) {
      videoID = $html5Video.find('[data-plyr-video-id]').data('plyr-video-id');
    } else if ($youtubeVideo.length > 0) {
      videoID = $youtubeVideo.find('iframe').attr('id');
    }
    if (videoID) {
      $.each(videoPlayers, function (index, player) {
        if (player.id == videoID || player.media.id == videoID) {
          if (player.playing) {
            player.pause();
          }
        }
      });
    }
  }
 
};
$(document).ready(function() {
  window.PXUTheme.mobileMenu.init();
});